import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import { toast } from 'react-toastify'; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)
// import InfiniteScroll from "react-infinite-scroll-component";
// import ContentItem from "../../components/ContentItem";
import NumberFormat from 'react-number-format';
import { isMobile, isAndroid, isIOS } from 'react-device-detect';
// import Modal from "react-responsive-modal";

class MyCashNew extends Component {
  state = {
    gotoPage: 1,
    pageCount: 1,
    pageSize: 10,
    dataList: [],
    cardRegShow: false,
    cardListOpen: false,
  };
  _isMounted = false;
  componentDidMount = () => {
    this._isMounted = true;
    this._getData(1);
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };
  _getData = async (gotoPage) => {
    const { loginId, pkg } = this.props;

    if (
      loginId === null ||
      loginId === undefined ||
      loginId === '' ||
      pkg === null ||
      pkg === undefined ||
      pkg === ''
    ) {
    } else {
      const result = await this._getDataApi(gotoPage);
      if (result) {
        const intReturn = result.data[0].intReturn;
        const pageCount = result.data[0].pageCount;
        const con = result.data[0].con;
        const cash = result.data[0].cash;
        const dataList = result.data[0].listData;
        //console.log(con)

        if (this._isMounted) {
          if (intReturn === 0) {
            if (con > 0) {
              //console.log('con > 0')
              this.setState({
                gotoPage: gotoPage,
                pageCount: pageCount,
                con: con,
                cash: cash,
                dataList: dataList,
                hasMore: pageCount < gotoPage ? false : true,
              });
            } else {
              //console.log('con < 0')
              this.setState({
                gotoPage: 1,
                pageCount: 1,
                con: con,
                cash: cash,
                searchList: [],
                hasMore: pageCount < gotoPage ? false : true,
              });
            }
          } else {
            //console.log('intReturn <> 0')
            this.setState({
              gotoPage: 1,
              pageCount: 1,
              con: con,
              cash: cash,
              dataList: [],
              hasMore: pageCount < gotoPage ? false : true,
            });
          }
        }
      }
    }
  };
  _getDataApi = (gotoPage) => {
    const { apiUrl, loginId, authId, pkg, history } = this.props;
    // const at = localStorage.getItem("at");
    const at = this.getCookie('at');
    return axios
      .post(
        apiUrl + '/myCash_pkg',
        {
          params: {
            userid: loginId,
            authId: authId,
            gotoPage: gotoPage,
            pkg: pkg,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      )
      .then((response) => response)
      .catch((error) => {
        //alert('오류가 발생했습니다.')
        if (error.response.status === 403) {
          //console.log('refresh....token...')
          this._refreshToken();
        } else if (error.response.status === 400) {
          history.push('/login');
        }
      });
  };
  _refreshToken = async () => {
    const { gotoPage } = this.state;
    const { history, apiUrl, setLoginId, setAuthId, loginId } = this.props;
    // const rt = localStorage.getItem('rt');
    const rt = this.getCookie('rt');
    if (rt === '' || rt === undefined || rt === null) {
      history.push('/login');
      return false;
    }

    const { data } = await axios.post(apiUrl + '/refreshToken', {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      localStorage.setItem('at', data[0].at);
      this._getData(gotoPage);
    } else {
      this.setCookie('account', '');

      setLoginId('');
      setAuthId('');

      setTimeout(() => {
        history.push('/login');
      }, 500);
    }
  };
  setCookie = (name, value, exp) => {
    let expires;
    if (exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else {
      expires = '';
    }
    document.cookie =
      name +
      '=' +
      value +
      ';expires=' +
      expires +
      ';path=/; SameSite=None; Secure; domain=aniplustv.com';
  };
  _onItems = (contentSerial) => {
    const { setContentSerial } = this.props;
    setContentSerial(contentSerial);
  };
  _renderItem = () => {
    const { dataList } = this.state;
    const list = dataList.map((item, index) => {
      return (
        <tr key={index}>
          <td>{item.chargedDate}</td>
          <td>
            <b className="wh">{item.cashName}</b>
            <p className="sm">
              {item.title === '' ||
              item.title === null ||
              item.title === undefined ? null : (
                <span
                  style={{ color: 'orange', cursor: 'pointer' }}
                  onClick={() => this._onItems(item.contentSerial)}
                >
                  ({item.title}-{item.subTitle})
                </span>
              )}
            </p>
          </td>
          <td>{item.expiredDate}</td>
          <td>
            <span
              className={
                item.cashFlag === 'M'
                  ? 'blue'
                  : item.cashFlag === 'A'
                  ? 'org'
                  : item.cashFlag === 'C'
                  ? 'red'
                  : null
              }
            >
              <b>
                <NumberFormat
                  displayType={'text'}
                  value={item.cash}
                  thousandSeparator={true}
                />
              </b>
              포인트
              <br />
              {item.cashFlag === 'A'
                ? '적립'
                : item.cashFlag === 'C'
                ? '충전'
                : item.cashFlag === 'M'
                ? '사용'
                : null}
            </span>
          </td>
        </tr>

        /*
                <tr key={index}>
                    <td><span className={item.cash >= 0 ? 'color_2' : 'color_1'} >{ item.cashFlag === 'A' ? '적립' : item.cashFlag === 'C' ? '충전' : item.cashFlag === 'M' ? '사용' : null }</span></td>
                    <td>{item.chargedDate}</td>
                    <td><div>{item.cashName} {item.title === '' || item.title === null || item.title === undefined ? null : <span style={{color: 'orange', cursor: 'pointer'}} onClick={()=>this._onItems(item.contentSerial)}>({item.title}-{item.subTitle})</span>}</div></td>
                    <td>{item.expiredDate}</td>
                    <td><span className={item.cash >= 0 ? 'color_2' : 'color_1'}>
                        <NumberFormat displayType={'text'} value={item.cash} thousandSeparator={true} /></span>
                    </td>
                </tr>
                */
      );
    });

    return list;
  };
  _CommaFormatted = (str) => {
    ////console.log('aaaaaaaaaaaaaaaa')
    var Money;
    Money = '';
    while (parseInt(str) >= 1000) {
      if (parseInt(str) / 1000 > 0) {
        if (parseInt(str) % 1000 === 0) {
          Money = ',' + (parseInt(str) % 1000) + '00' + Money;
        } else {
          if (parseInt(str) % 1000 > 99)
            Money = ',' + (parseInt(str) % 1000) + Money;
          else if (parseInt(str) % 1000 > 9)
            Money = ',0' + (parseInt(str) % 1000) + Money;
          else Money = ',00' + (parseInt(str) % 1000) + Money;
        }
      }
      str = parseInt(str) / 1000;
    }
    Money = parseInt(str) + Money;

    return Money;
  };
  _onCardReg = () => {
    const { setCardRegShow } = this.props;
    setCardRegShow(true);
  };

  _onCardList = () => {
    const { setCardListShow } = this.props;
    setCardListShow(true);
  };
  _renderPage = () => {
    const { gotoPage, con, pageCount } = this.state;

    const dataPerPage = isMobile ? 5 : 10; //한페이지에 보여질 갯수
    let pageCount1;

    if (pageCount > dataPerPage) {
      pageCount1 = dataPerPage;
    } else {
      pageCount1 = pageCount;
    }
    const pageNumbers = [];

    const totalPage = Math.ceil(con / dataPerPage); //총페이지수

    const pageGroup = Math.ceil(gotoPage / pageCount1); //페이지 그룹
    let last = pageGroup * pageCount1;

    if (last > totalPage) {
      last = totalPage;
    }

    let first = last - (pageCount1 - 1); //화면에 보여질 첫번째 페이지 번호

    const next = last + 1;
    // const prev = first - 1;

    if (totalPage < 1) {
      first = last;
    }

    if (first > pageCount1) {
    } else {
    }

    if (next > pageCount1 && next < totalPage) {
    } else {
    }

    for (let j = first; j <= last; j++) {
      pageNumbers.push(j);
    }

    const list = pageNumbers.map((num, index) => {
      return (
        <span
          key={index}
          style={{ cursor: 'pointer' }}
          onClick={() => this._getData(num)}
          className={gotoPage === num ? 'on' : null}
        >
          {num}
        </span>
        /*<a href="#" className={gotoPage === num ? "active" : null } onClick={()=>this._page(num)} key={index}>{num}</a>*/
      );
    });

    return (
      <Fragment>
        {first > pageCount1 ? (
          <span onClick={this._onPrev}>이전</span>
        ) : (
          <span style={{ backgroundColor: '#000' }}></span>
        )}
        {list}
        {next > pageCount1 && next < totalPage ? (
          <span onClick={this._onNext}>다음</span>
        ) : (
          <span style={{ backgroundColor: '#000' }}></span>
        )}
      </Fragment>
    );
  };

  _onPrev = () => {
    const { gotoPage } = this.state;

    if (gotoPage === 1) {
      //alert('페이지의 처음입니다.')
      toast.warn('페이지의 처음입니다.');
    } else {
      this._getData(gotoPage - 1);
    }
  };
  _onNext = () => {
    const { gotoPage, pageCount } = this.state;
    if (gotoPage + 1 >= pageCount) {
      toast.warn('페이지의 마지막입니다.');
      //alert('페이지의 마지막입니다.')
    } else {
      this._getData(gotoPage + 1);
    }
  };
  _goCash = () => {
    const { history } = this.props;

    history.push('/ticket');
  };
  render() {
    // const { tabIndex } = this.props.childProps;
    const { dataList, con } = this.state;
    return (
      <Fragment>
        <div className="list_wrap">
          <div className="listHead">
            <span className="total">
              총 <em>{con}</em>개
            </span>
            <div className="fl_rt">
              <button type="button" className="btn_del" onClick={this._goCash}>
                포인트 충전하기
              </button>
            </div>
          </div>
          <div className="list">
            <table className="pay_cash">
              <thead>
                <tr>
                  <th>결제일</th>
                  <th>사용내역</th>
                  <th>만료일</th>
                  <th>포인트결제</th>
                </tr>
              </thead>
              <tbody>{dataList ? this._renderItem() : null}</tbody>
            </table>
          </div>
          <div className="page_no">{dataList ? this._renderPage() : null}</div>
        </div>

        {/*카드 등록 */}

        {/*            
                <ToastContainer 
                    position="bottom-right"
                    hideProgressBar
                />
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(MyCashNew));
